<svg viewBox="0 0 13 22" xmlns="http://www.w3.org/2000/svg">
<path d="M12.6666 11.1969L6.53378 15.0031L0.396973 11.1969L6.53378 0.5L12.6666 11.1969ZM6.53378 16.2254L0.396973 12.4191L6.53378 21.5L12.6706 12.4191L6.53378 16.2254V16.2254Z" />
</svg>
